import { MANIFESTO } from "../../lib/site-content";
import { Reveal, StaggerGroup, StaggerItem } from "./Reveal";

export const Manifesto = () => {
  return (
    <section
      data-testid="manifesto-section"
      className="relative bg-white py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-3xl">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            Onze Meerwaarde
          </p>
          <h2 className="font-display text-3xl font-bold tracking-tight text-[#0F172A] sm:text-4xl lg:text-5xl">
            Waarom ondernemers voor ons kiezen
          </h2>
        </Reveal>

        <StaggerGroup className="mt-16 grid grid-cols-1 gap-x-12 gap-y-14 md:grid-cols-3">
          {MANIFESTO.map((m) => (
            <StaggerItem key={m.no}>
              <div className="group border-t border-slate-200 pt-8">
                <span className="font-display text-6xl font-thin tracking-tighter text-slate-200 transition-colors duration-300 group-hover:text-[#F59E0B] lg:text-7xl">
                  {m.no}
                </span>
                <h3 className="mt-6 font-display text-xl font-bold leading-tight text-[#0F172A] lg:text-2xl">
                  {m.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-slate-600">
                  {m.desc}
                </p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
